// src/firebase.js
// Replace these values with your actual Firebase project config
// from https://console.firebase.google.com → Project Settings → Your apps

import { initializeApp } from 'firebase/app';
import { initializeFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCpvOMRuJyUpfWc9y10XYojVNRoIocuioU",
  authDomain: "comfystack.firebaseapp.com",
  projectId: "comfystack",
  storageBucket: "comfystack.firebasestorage.app",
  messagingSenderId: "311059662753",
  appId: "1:311059662753:web:cb454e8563079156716de0",
  measurementId: "G-JKTLZSN969"
};

const app = initializeApp(firebaseConfig);

// Force Firestore onto long-polling instead of its default streaming
// (WebChannel) transport. Some corporate firewalls/proxies — especially
// ones doing SSL inspection — buffer or silently kill long-lived
// streaming connections without ever throwing an error. That leaves
// onSnapshot/getDocs calls hanging indefinitely, which shows up exactly
// as a stuck skeleton loader with no error message.
// useFetchStreams: false makes the long-polling fallback use the older
// XHR-based implementation instead of the Fetch streaming API, which is
// more compatible with older/aggressive corporate proxies and antivirus
// software. Trade-off is a bit more request overhead per listener, which
// is a non-issue for a workflow catalog that isn't doing high-frequency
// realtime updates.
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
  useFetchStreams: false,
});

export const storage = getStorage(app);
export const auth = getAuth(app);
export default app;
